/**
 * PCM 2026 Theme - Custom JavaScript
 * Handles Swiper carousels, YouTube videos, star ratings, and modal forms
 */

(function($) {
  'use strict';

  function pcmConsentAllows(category) {
    if (window.pcmConsentAllowsCategory && typeof window.pcmConsentAllowsCategory === 'function') {
      return window.pcmConsentAllowsCategory(category);
    }

    if (window.pcmConsentManager && typeof window.pcmConsentManager.canLoad === 'function') {
      return window.pcmConsentManager.canLoad(category);
    }

    return window.pcmConsentRequiresOptIn !== true;
  }

  function pcmRunWithConsent(category, callback) {
    let hasRun = false;

    function runIfAllowed() {
      if (hasRun || !pcmConsentAllows(category)) {
        return;
      }

      hasRun = true;
      document.removeEventListener('pcm_consent_update', runIfAllowed);
      document.removeEventListener('cookieyes_consent_update', runIfAllowed);
      document.removeEventListener('cky_consent_update', runIfAllowed);
      window.removeEventListener('pcm_consent_update', runIfAllowed);
      window.removeEventListener('cookieyes_consent_update', runIfAllowed);
      window.removeEventListener('cky_consent_update', runIfAllowed);
      callback();
    }

    runIfAllowed();
    document.addEventListener('pcm_consent_update', runIfAllowed);
    document.addEventListener('cookieyes_consent_update', runIfAllowed);
    document.addEventListener('cky_consent_update', runIfAllowed);
    window.addEventListener('pcm_consent_update', runIfAllowed);
    window.addEventListener('cookieyes_consent_update', runIfAllowed);
    window.addEventListener('cky_consent_update', runIfAllowed);
  }

  /**
   * Initialize all components when DOM is ready
   */
  $(document).ready(function() {
    // Videos embed directly in each provider's privacy-enhanced mode
    // (youtube-nocookie, Vimeo dnt) instead of waiting for marketing consent,
    // which left visitors in opt-in states with empty players.
    initializeYouTubeVideos();
    initializeStarRatings();
    initializeReviewsSwiper();
    initializeCaseStudyGalleries();
    // Auto Play YouTube Video Group

    // Video switcher
    $('.video-group-link').click(function (e) {
      $('html, body').animate({
        scrollTop: $("#video-group-player").offset().top - 150
      }, 500);
      var videoid = $(this).data('videoid')
      $('.video-group-link').parent().removeClass('video--active');
      $(this).parent().addClass('video--active');
      autoPlayVideo(videoid);
      e.preventDefault();
    });

    // Vimeo switcher
    $('.vimeo-group-link').click(function (e) {
      if ($(this).parent().hasClass('video--active')) {
        e.preventDefault();
        return;
      }
      var $vimeoGroupPlayer = $(this).closest('.vimeo-group').find('.vimeo-group-player');
      $('html, body').animate({
        scrollTop: $vimeoGroupPlayer.offset().top - 150
      }, 500);
      var videoid = $(this).data('videoid');
      $('.vimeo-group-link').parent().removeClass('video--active');
      $('.vimeo-group-link').removeClass('disabled');
      $(this).parent().addClass('video--active');
      $(this).addClass('disabled');
      $vimeoGroupPlayer.html('<iframe class="rounded-3" src="https://player.vimeo.com/video/' + videoid + '?autoplay=1&dnt=1&title=0&byline=0&portrait=0" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>');
      e.preventDefault();
    });
  });

  /**
   * Star Rating Input Handler
   * Handles interactive star rating inputs with hover and selection.
   * Colors match Figma: #ffb004 gold for a filled star, --pcm-line for an empty
   * one. These are set inline, so they win over the CSS in
   * sass/partials/_review-grid.scss -- keep the two in step.
   */
  function initializeStarRatings() {
    const starRatingInputs = document.querySelectorAll('.star-rating-input');
    
    starRatingInputs.forEach((ratingContainer) => {
      const labels = ratingContainer.querySelectorAll('.star-label');

      labels.forEach((label, index) => {
        const input = label.querySelector('input');
        const star = label.querySelector('i');

        if (!input || !star) return;

        // Handle click/selection
        input.addEventListener('change', function() {
          // Reset all stars
          labels.forEach((l) => {
            l.querySelector('i').style.color = '#d8d8dc';
          });

          // Fill stars up to selected
          for (let i = 0; i <= index; i++) {
            labels[i].querySelector('i').style.color = '#ffb004';
          }
        });

        // Handle hover
        label.addEventListener('mouseenter', function() {
          for (let i = 0; i <= index; i++) {
            labels[i].querySelector('i').style.color = '#ffb004';
          }
          for (let i = index + 1; i < labels.length; i++) {
            labels[i].querySelector('i').style.color = '#d8d8dc';
          }
        });
      });

      // Reset to selected on mouse leave
      ratingContainer.addEventListener('mouseleave', function() {
        const checkedInput = ratingContainer.querySelector('input:checked');
        if (checkedInput) {
          const checkedIndex = Array.from(labels).findIndex(l => 
            l.querySelector('input') === checkedInput
          );
          labels.forEach((l, i) => {
            l.querySelector('i').style.color = i <= checkedIndex ? '#ffb004' : '#d8d8dc';
          });
        } else {
          labels.forEach((l) => {
            l.querySelector('i').style.color = '#d8d8dc';
          });
        }
      });
    });
  }

  /**
   * Initialize Reviews Swiper Carousel
   * Used on reviews sections
   */
  function initializeReviewsSwiper() {
    const reviewCarousels = document.querySelectorAll('.block-reviews__carousel');

    if (reviewCarousels.length === 0) return;

    if (typeof Swiper === 'undefined') {
      pcmRunWithConsent('functional', function() {
        setTimeout(initializeReviewsSwiper, 100);
      });
      return;
    }

    // Ensure Swiper CSS is loaded
    if (window.loadSwiperCSS) {
      window.loadSwiperCSS();
    }

    // Initialize after CSS loads
    setTimeout(() => {
      reviewCarousels.forEach((carousel) => {
        const reviewsSwiper = carousel.querySelector('.block-reviews-swiper');

        if (!reviewsSwiper || reviewsSwiper.classList.contains('swiper-initialized')) {
          return;
        }

        new Swiper(reviewsSwiper, {
          slidesPerView: 1,
          spaceBetween: 20,
          loop: true,
          navigation: {
            nextEl: carousel.querySelector('.block-reviews__button-next'),
            prevEl: carousel.querySelector('.block-reviews__button-prev'),
          },
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            }
          }
        });
      });
    }, 50);
  }

  /**
   * Initialize Case Study Gallery Swipers
   * Used on case study pages for image galleries
   */
  function initializeCaseStudyGalleries() {
    const caseStudyGalleries = document.querySelectorAll('.case-study-gallery-swiper:not(.swiper-initialized)');
    
    if (caseStudyGalleries.length === 0) return;

    if (typeof Swiper === 'undefined') {
      pcmRunWithConsent('functional', function() {
        setTimeout(initializeCaseStudyGalleries, 100);
      });
      return;
    }

    // Ensure Swiper CSS is loaded
    if (window.loadSwiperCSS) {
      window.loadSwiperCSS();
    }

    setTimeout(() => {
      caseStudyGalleries.forEach((gallery) => {
        const slides = gallery.querySelectorAll('.swiper-slide');
        
        // Only initialize if multiple slides exist
        if (slides.length > 1) {
          new Swiper(gallery, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            navigation: {
              nextEl: gallery.querySelector('.swiper-button-next'),
              prevEl: gallery.querySelector('.swiper-button-prev'),
            },
            pagination: {
              el: gallery.querySelector('.swiper-pagination'),
              clickable: true,
            },
            effect: 'slide',
            speed: 300,
            watchOverflow: true,
            observer: true,
            observeParents: true
          });
        }
      });
    }, 100);
  }

  /**
   * Initialize YouTube Videos
   * Converts .ytvideo and .video--muted divs with data-videoid into embedded iframes
   */
  function initializeYouTubeVideos() {
    const ytvideos = document.querySelectorAll('.ytvideo, .video--muted, .video');
    
    if (ytvideos.length === 0) return;

    ytvideos.forEach((videoDiv) => {
      const videoID = videoDiv.dataset.videoid;
      
      // Skip if no video ID or already has iframe
      if (!videoID || videoDiv.querySelector('iframe')) return;

      try {
        const iframe = document.createElement('iframe');
        
        // Check if this is a muted autoplay video
        const isMuted = videoDiv.classList.contains('video--muted');
        const autoplayParam = isMuted ? '&autoplay=1&mute=1&loop=1&playlist=' + videoID : '';
        
        // All-digit ids are Vimeo (the ESB video, 982111375); the rest YouTube.
        iframe.src = /^\d+$/.test(String(videoID))
          ? `https://player.vimeo.com/video/${videoID}?dnt=1${isMuted ? '&autoplay=1&muted=1&loop=1' : ''}`
          : `https://www.youtube-nocookie.com/embed/${videoID}?controls=1&modestbranding=1&rel=0&enablejsapi=1${autoplayParam}`;
        iframe.frameBorder = '0';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; fullscreen; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        
        // Only apply absolute positioning if inside an embed-container
        const isInEmbedContainer = videoDiv.closest('.embed-container') !== null;
        if (isInEmbedContainer) {
          iframe.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;';
        } else {
          iframe.style.cssText = 'width:100%;height:100%;display:block;';
        }
        
        // Add rounded corners
        iframe.classList.add('rounded-4');
        videoDiv.classList.add('rounded-4');
        
        videoDiv.appendChild(iframe);
        videoDiv.classList.add('video-loaded');
      } catch (error) {
        console.error('Error creating YouTube iframe:', error);
      }
    });
  }

  // Expose YouTube init for external use if needed
  window.initializeYouTubeVideos = initializeYouTubeVideos;

  /**
   * YouTube IFrame API Ready Callback
   * Required for YouTube API integration if used
   */
  window.onYouTubeIframeAPIReady = function() {
    initializeYouTubeVideos();
  };

  // Load video into div / Auto play video
  function autoPlayVideo(videoid) {
    $("#video-group-player").html('<iframe width="450" height="283" src="https://www.youtube-nocookie.com/embed/' + videoid + '?autoplay=1&loop=1&rel=0&wmode=transparent" frameborder="0" allowfullscreen wmode="opaque"></iframe>');
  }
  
  function autoPlayVimeo(videoid) {
    $("#vimeo-group-player").html('<iframe src="https://player.vimeo.com/video/' + videoid + '?autoplay=1&dnt=1&title=0&byline=0&portrait=0" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>');
  }

  // Fetch vimeo thumbnail
  function fetchVimeoThumbnail(videoId) {
    const oEmbedUrl = `https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/${videoId}`;

    return fetch(oEmbedUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response error ' + response.statusText);
        }
        return response.json();
      })
      .then(data => data.thumbnail_url)
      .catch(error => console.error('Error fetching thumbnail:', error));
  }

})(jQuery);

/**
 * Get a live nonce for a public AJAX lookup. The nonce printed in the page can
 * have expired, since pages are cached for 24h and nonces last 12-24h (see
 * inc/forms/fresh-nonces.php). Callers use this to retry once after an
 * "Invalid nonce" response. Resolves to the nonce, or rejects.
 */
window.pcmFetchFreshNonce = function (action) {
  var body = new FormData();
  body.append('action', 'pcm_fresh_form_nonces');
  body.append('actions[]', action);

  return fetch(window.pcmAjax.ajax_url, { method: 'POST', body: body, credentials: 'same-origin' })
    .then(function (response) {
      return response.json();
    })
    .then(function (result) {
      if (result && result.success && result.data && result.data[action]) {
        return result.data[action];
      }
      throw new Error('Could not refresh the ' + action + ' nonce');
    });
};
